var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("div", { staticClass: "search_group" }, [
        _c(
          "div",
          { staticClass: "search_row" },
          [
            _c("el-date-picker", {
              staticClass: "search_item",
              attrs: {
                "disabled-date": _vm.disabledDate,
                clearable: "",
                "value-format": "yyyy-MM-dd",
                type: "daterange",
                "start-placeholder": "下单开始时间",
                "end-placeholder": "下单结束时间",
                size: "small",
                "unlink-panels": "",
                "picker-options": _vm.expireTimeOption,
              },
              model: {
                value: _vm.createTime,
                callback: function ($$v) {
                  _vm.createTime = $$v
                },
                expression: "createTime",
              },
            }),
            _c("el-date-picker", {
              staticClass: "search_item",
              attrs: {
                clearable: "",
                "value-format": "yyyy-MM-dd",
                type: "daterange",
                "start-placeholder": "支付开始时间",
                "end-placeholder": "支付结束时间",
                size: "small",
                "unlink-panels": "",
                "picker-options": _vm.expireTimeOption,
              },
              model: {
                value: _vm.payTime,
                callback: function ($$v) {
                  _vm.payTime = $$v
                },
                expression: "payTime",
              },
            }),
            _c("el-date-picker", {
              staticClass: "search_item",
              attrs: {
                "disabled-date": _vm.disabledDate,
                clearable: "",
                "value-format": "yyyy-MM-dd",
                type: "daterange",
                "start-placeholder": "退款开始时间",
                "end-placeholder": "退款结束时间",
                size: "small",
                "unlink-panels": "",
                "picker-options": _vm.expireTimeOption,
              },
              model: {
                value: _vm.refundTime,
                callback: function ($$v) {
                  _vm.refundTime = $$v
                },
                expression: "refundTime",
              },
            }),
            _c("el-input", {
              staticClass: "search_item",
              attrs: {
                maxlength: 30,
                size: "small",
                placeholder: "订单编号/商户单号/流水...",
                clearable: "",
              },
              model: {
                value: _vm.orderNum,
                callback: function ($$v) {
                  _vm.orderNum = $$v
                },
                expression: "orderNum",
              },
            }),
            _c("el-input", {
              staticClass: "search_item",
              attrs: {
                maxlength: 30,
                size: "small",
                placeholder: "用户账号",
                clearable: "",
              },
              model: {
                value: _vm.mobile,
                callback: function ($$v) {
                  _vm.mobile = $$v
                },
                expression: "mobile",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search_row" },
          [
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "业务类型",
                },
                model: {
                  value: _vm.bussiTypeParams,
                  callback: function ($$v) {
                    _vm.bussiTypeParams = $$v
                  },
                  expression: "bussiTypeParams",
                },
              },
              _vm._l(_vm.businessTypeList, function (item) {
                return _c("el-option", {
                  key: item.dictKey,
                  attrs: { label: item.dictValue, value: item.dictKey },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "收款商户类型",
                },
                model: {
                  value: _vm.merchantIdParams,
                  callback: function ($$v) {
                    _vm.merchantIdParams = $$v
                  },
                  expression: "merchantIdParams",
                },
              },
              _vm._l(_vm.merchantList, function (item) {
                return _c("el-option", {
                  key: item.merchantId,
                  attrs: { label: item.merchantName, value: item.merchantId },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "支付方式",
                },
                model: {
                  value: _vm.payTypeParams,
                  callback: function ($$v) {
                    _vm.payTypeParams = $$v
                  },
                  expression: "payTypeParams",
                },
              },
              _vm._l(_vm.payTypeList, function (item) {
                return _c("el-option", {
                  key: item.dictKey,
                  attrs: { label: item.dictValue, value: item.dictKey },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "购买来源",
                },
                model: {
                  value: _vm.productIdParams,
                  callback: function ($$v) {
                    _vm.productIdParams = $$v
                  },
                  expression: "productIdParams",
                },
              },
              _vm._l(_vm.productList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.pname, value: item.id },
                })
              }),
              1
            ),
            _c("DynamicOption", {
              staticClass: "search_item",
              attrs: {
                placeholder: "请选择渠道",
                singleSelect: false,
                params: _vm.searchOptions,
                size: "small",
              },
              model: {
                value: _vm.appids,
                callback: function ($$v) {
                  _vm.appids = $$v
                },
                expression: "appids",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search_row" },
          [
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "订单类型",
                },
                model: {
                  value: _vm.orderTypeFilterParams,
                  callback: function ($$v) {
                    _vm.orderTypeFilterParams = $$v
                  },
                  expression: "orderTypeFilterParams",
                },
              },
              [
                _c("el-option", { attrs: { label: "普通订单", value: 1 } }),
                _c("el-option", { attrs: { label: "加购订单", value: 2 } }),
              ],
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "商品类型",
                },
                model: {
                  value: _vm.goodsTypeFilterParams,
                  callback: function ($$v) {
                    _vm.goodsTypeFilterParams = $$v
                  },
                  expression: "goodsTypeFilterParams",
                },
              },
              [
                _c("el-option", { attrs: { label: "会员服务", value: 1 } }),
                _c("el-option", { attrs: { label: "设备服务", value: 4 } }),
                _c("el-option", { attrs: { label: "激活码", value: "2,3" } }),
              ],
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "订单商品类型",
                },
                model: {
                  value: _vm.mtypeIdParams,
                  callback: function ($$v) {
                    _vm.mtypeIdParams = $$v
                  },
                  expression: "mtypeIdParams",
                },
              },
              _vm._l(_vm.serverTypeList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.typeName, value: item.id },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "会员商品名称",
                },
                model: {
                  value: _vm.goodsIds,
                  callback: function ($$v) {
                    _vm.goodsIds = $$v
                  },
                  expression: "goodsIds",
                },
              },
              _vm._l(_vm.goodsNameOptions, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "订单状态",
                },
                model: {
                  value: _vm.statusParams,
                  callback: function ($$v) {
                    _vm.statusParams = $$v
                  },
                  expression: "statusParams",
                },
              },
              [
                _c("el-option", { attrs: { label: "未支付", value: 0 } }),
                _c("el-option", { attrs: { label: "支付成功", value: 1 } }),
                _c("el-option", { attrs: { label: "支付失败", value: 2 } }),
                _c("el-option", { attrs: { label: "已作废", value: 3 } }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search_row" },
          [
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "退款状态",
                },
                model: {
                  value: _vm.refundStatusParams,
                  callback: function ($$v) {
                    _vm.refundStatusParams = $$v
                  },
                  expression: "refundStatusParams",
                },
              },
              [
                _c("el-option", { attrs: { label: "未申请", value: 0 } }),
                _c("el-option", { attrs: { label: "待处理", value: 1 } }),
                _c("el-option", { attrs: { label: "退款失败", value: 2 } }),
                _c("el-option", { attrs: { label: "已退款", value: 3 } }),
                _c("el-option", { attrs: { label: "拒绝退款", value: 4 } }),
              ],
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_item",
                attrs: {
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "补单状态",
                },
                model: {
                  value: _vm.supplementStatusParams,
                  callback: function ($$v) {
                    _vm.supplementStatusParams = $$v
                  },
                  expression: "supplementStatusParams",
                },
              },
              [
                _c("el-option", { attrs: { label: "未申请", value: 0 } }),
                _c("el-option", { attrs: { label: "待处理", value: 1 } }),
                _c("el-option", { attrs: { label: "已补单", value: 2 } }),
                _c("el-option", { attrs: { label: "已拒绝", value: 3 } }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search_item search_buttons" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "order_search",
                        expression: "'order_search'",
                      },
                    ],
                    attrs: {
                      icon: "el-icon-search",
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.searchAct },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "order_export",
                        expression: "'order_export'",
                      },
                    ],
                    attrs: {
                      icon: "el-icon-download",
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.exportList },
                  },
                  [_vm._v("导出为Excel")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
            "row-style": { height: "30px" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: "ID",
              width: "80",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bussiTypeName",
              label: "业务类型",
              width: "100",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "merchantName",
              label: "收款商户",
              width: "80",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "订单编号", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: scope.row.orderNum,
                            expression: "scope.row.orderNum",
                            arg: "copy",
                          },
                        ],
                        on: { click: _vm.copyTip },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.orderNum) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "relatedOrderNum", label: "关联订单", width: "220" },
          }),
          _c("el-table-column", {
            attrs: { prop: "orderTitle", label: "订单标题", width: "220" },
          }),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "购买来源", width: "150" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "payTradeNo",
              label: "商户单号",
              width: "200",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "transactionId", label: "交易流水号", width: "300" },
          }),
          _c("el-table-column", {
            attrs: { prop: "mtypeName", label: "订单商品类型", width: "200" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsName",
              label: "订单商品名称",
              width: "200",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "商品类型", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm.getGoodsTypeDesc(scope.row.goodsType))),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "mobile", label: "用户账号", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { label: "来源渠道", width: "400" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.getSourceChannel(scope.row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "下单时间", width: "170" },
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "商品原价（元）", width: "130" },
          }),
          _c("el-table-column", {
            attrs: { label: "商品折扣价（元）", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.discount > 0 ? scope.row.discount : 0)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "抵扣金额", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.deduction > 0 ? scope.row.deduction : 0)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "quantity", label: "订单数量", width: "100" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "payNum",
              label: "支付金额（元）",
              width: "130",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "settleAmount",
              label: "财务结算金额",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "payTime", label: "支付时间", width: "170" },
          }),
          _c("el-table-column", {
            attrs: { label: "支付方式", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getPayTypeDescByPayType(scope.row.payType) ||
                            scope.row.payType
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订单状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getOrderStatusDesc(scope.row.status) ||
                            scope.row.status
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订单类型", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getGiveStatus(scope.row.isgive)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "refundTime", label: "退款时间", width: "170" },
          }),
          _c("el-table-column", {
            attrs: { label: "退款状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getRefundStatusDesc(scope.row.refundStatus)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "补单状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getSupplementStatusDesc(
                            scope.row.supplementStatus
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "mark", label: "备注", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", width: "150", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.canShowRefundButton(scope.row)
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "order_apply_refund",
                                expression: "'order_apply_refund'",
                              },
                            ],
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("\n          申请退款\n        ")]
                        )
                      : scope.row.isVoid == 0 &&
                        scope.row.status == 1 &&
                        (scope.row.refundStatus == null ||
                          scope.row.refundStatus == 0 ||
                          scope.row.refundStatus == 4) &&
                        scope.row.payType == 5 &&
                        scope.row.supplementStatus != 1 &&
                        scope.row.supplementStatus != 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "order_ios_refund",
                                expression: "'order_ios_refund'",
                              },
                            ],
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 4)
                              },
                            },
                          },
                          [_vm._v("IOS退款\n        ")]
                        )
                      : scope.row.refundStatus == 3 && scope.row.payType == 11
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "order_doudian_refund_right",
                                expression: "'order_doudian_refund_right'",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 3)
                              },
                            },
                          },
                          [_vm._v("抖店退回权益\n        ")]
                        )
                      : scope.row.status == 0 &&
                        (!scope.row.supplementStatus ||
                          scope.row.supplementStatus == 0 ||
                          scope.row.supplementStatus == 3)
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "order_apply_supplement",
                                expression: "'order_apply_supplement'",
                              },
                            ],
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 2)
                              },
                            },
                          },
                          [_vm._v("申请补单\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款申请",
            visible: _vm.showDetails,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetails = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "110px",
                "label-height": "50px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.checkItem.orderNum) + "\n      "
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "用户账户" } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.checkItem.mobile) + "\n        "
                  ),
                  _vm.checkItem.userChangeMobileRecords &&
                  _vm.checkItem.userChangeMobileRecords.length > 0
                    ? _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-left": "70px",
                            color: "#409EFF",
                          },
                          attrs: { type: "text", size: "mini" },
                          on: {
                            click: function ($event) {
                              _vm.showChangeMobileDialog = true
                            },
                          },
                        },
                        [_vm._v("\n          换绑记录\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "支付方式" } }, [
                _vm._v(
                  _vm._s(
                    _vm.getPayTypeDescByPayType(_vm.checkItem.payType) ||
                      _vm.checkItem.payType
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "支付金额" } }, [
                _vm._v("¥ " + _vm._s(_vm.checkItem.payNum)),
              ]),
              _c("el-form-item", { attrs: { label: "折算金额" } }, [
                _vm._v("¥ " + _vm._s(_vm.getObversionNum(_vm.checkItem))),
              ]),
              _c("el-divider"),
              _c(
                "el-form-item",
                { attrs: { label: "退款方式" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.refundType,
                        callback: function ($$v) {
                          _vm.refundType = $$v
                        },
                        expression: "refundType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "2", size: "large" } }, [
                        _vm._v("退款且退货"),
                      ]),
                      _c("el-radio", { attrs: { label: "1", size: "large" } }, [
                        _vm._v("退款不退货"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款金额" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "请输入退款金额",
                      type: "number",
                      min: 0,
                      precision: 2,
                      step: 0.01,
                      size: "small",
                    },
                    model: {
                      value: _vm.refundPrice,
                      callback: function ($$v) {
                        _vm.refundPrice = $$v
                      },
                      expression: "refundPrice",
                    },
                  }),
                  _vm.refundType === "2" &&
                  _vm.setMemberType !== "2" &&
                  (_vm.checkItem.goodsType == 1 ||
                    _vm.checkItem.goodsType == 4) &&
                  _vm.checkItem.memberTimelineList
                    ? _c("el-text", { staticStyle: { color: "#999999" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(this.checkItem.maxRefundMoneyText) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              this.refundType == 2 &&
              (this.checkItem.goodsType == 1 || this.checkItem.goodsType == 4)
                ? _c(
                    "el-form-item",
                    { attrs: { label: "会员设置" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.setMemberType,
                            callback: function ($$v) {
                              _vm.setMemberType = $$v
                            },
                            expression: "setMemberType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("系统自动回收"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("手动设置到期时间"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.setMemberType === "2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "会员类型" } },
                    [
                      _c("el-text", [
                        _vm._v(
                          _vm._s(_vm.checkItem.memberName) + " \n          "
                        ),
                        _c("br"),
                        _vm._v(
                          "有效期：" +
                            _vm._s(this.checkItem.memberExpire) +
                            "\n          "
                        ),
                        _c("br"),
                        _vm._v("变更为-到期时间:\n        "),
                      ]),
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          placeholder: "请选择到期时间",
                          size: "small",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.checkItem.newExpireTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "newExpireTime", $$v)
                          },
                          expression: "checkItem.newExpireTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "退款原因类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.refundReasonType,
                        callback: function ($$v) {
                          _vm.refundReasonType = $$v
                        },
                        expression: "refundReasonType",
                      },
                    },
                    _vm._l(_vm.refundReasonTypeList, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.dictKey,
                          attrs: {
                            label: item.dictKey,
                            value: item.dictKey,
                            size: "large",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.dictValue) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款原因" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      size: "large",
                      placeholder: "请输入文字",
                    },
                    model: {
                      value: _vm.refundReason,
                      callback: function ($$v) {
                        _vm.refundReason = $$v
                      },
                      expression: "refundReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.checkItem.refundStatus == 1 || _vm.checkItem.refundStatus == 2
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showDetails = false
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
              _vm.checkItem.refundStatus != 1 && _vm.checkItem.refundStatus != 2
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "default",
                        icon: "el-icon-circle-close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeCheck(2)
                        },
                      },
                    },
                    [_vm._v("取消")]
                  )
                : _vm._e(),
              _vm.checkItem.refundStatus != 1 && _vm.checkItem.refundStatus != 2
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeCheck(3)
                        },
                      },
                    },
                    [_vm._v("确认申请退款")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "补单申请",
            visible: _vm.showSupplement,
            "append-to-body": "",
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSupplement = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "120px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.checkItem.orderNum) + "\n      "
                ),
              ]),
              _c("el-form-item", { attrs: { label: "用户账户" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.checkItem.mobile) + "\n      "
                ),
              ]),
              _c("el-form-item", { attrs: { label: "订单商品名称" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.checkItem.goodsName) + "\n      "
                ),
              ]),
              _c("el-form-item", { attrs: { label: "支付方式" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.getPayTypeDescByPayType(_vm.checkItem.payType) ||
                        _vm.checkItem.payType
                    ) +
                    "\n      "
                ),
              ]),
              _vm.checkItem.payType == 5
                ? _c(
                    "el-form-item",
                    { attrs: { label: "凭据", prop: "icon" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-items": "center",
                            "align-items": "center",
                          },
                        },
                        [
                          _vm.checkItem.file
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                  "margin-right": "10px",
                                },
                                attrs: {
                                  fit: "scale-down",
                                  src: _vm.checkItem.file,
                                },
                              })
                            : _vm._e(),
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                "before-upload": _vm.checkUpload,
                                "http-request": _vm.upload,
                                listType: "picture-img",
                                "on-preview": _vm.handlePreview,
                                "on-remove": _vm.handleRemove,
                                "before-remove": _vm.beforeRemove,
                                "on-exceed": _vm.handleExceed,
                                "show-file-list": false,
                                accept: "image/jpg,image/jpeg,image/png",
                              },
                            },
                            [
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v("点击上传文件"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.checkItem.payType != 5
                ? _c(
                    "el-form-item",
                    { attrs: { label: "支付方单据号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "输入支付方单据号",
                          size: "large",
                        },
                        model: {
                          value: _vm.checkItem.supplementPayNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "supplementPayNum", $$v)
                          },
                          expression: "checkItem.supplementPayNum",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 100,
                      resize: "none",
                      size: "large",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.checkItem.supplementMark,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "supplementMark", $$v)
                      },
                      expression: "checkItem.supplementMark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showSupplement = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.applySupplement },
                },
                [_vm._v("确认申请补单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "换绑记录",
            visible: _vm.showChangeMobileDialog,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showChangeMobileDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.checkItem.userChangeMobileRecords,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "oldMobile", label: "原手机号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "换绑手机号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "换绑时间" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showChangeMobileDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }